<template>
  <el-card class="user-box">
    <div class="toolbar">
      <el-button type="primary" @click="addItem()">
        <i class="fas fa-plus"></i> 新增用户
      </el-button>
    </div>
    <el-table v-loading="loading" :data="items">
      <el-table-column type="index" :index="pager.size * (pager.page - 1) + 1" />
      <el-table-column prop="Name" label="姓名" />
      <el-table-column prop="Username" label="登录名" />
      <el-table-column prop="Email" label="邮箱" />
      <el-table-column prop="Phone" label="手机号" />
      <!-- <el-table-column prop="Phone" label="角色" /> -->
      <el-table-column width="150" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click.stop="editItem(scope.row)" title="编辑">
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button type="danger" @click.stop="delItem(scope.row)" title="删除">
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="paginator pull-right mt-10 mb-10">
      <el-pagination
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
        @current-change="onChangePage"
      />
    </div>

    <item-form
      v-model="item"
      :visible.sync="editing"
      :park-list="parkList"
      :corp-list="corpList"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import * as _isArray from 'lodash/isArray';
import ItemForm from './index--form.vue';

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      items: [],
      item: this.getEmptyItem(),
      former: {
        name: '',
        subject_type: '',
        subject_id: '',
      },
      querier: {},
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      loading: false,
      editing: false,
      parkList: [],
      corpList: [],
    };
  },
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      const params = {
        ...this.querier,
        with: ['Roles', 'Departments'],
      };
      this.$axios.get('user', { params }).then((response) => {
        const list = response.data.data;
        list.map((ele) => {
          const obj = ele;
          obj.DepartmentIDs = _isArray(obj.Departments)
            ? obj.Departments.map(d => d.ID) : [];
          obj.RoleIDs = _.isArray(obj.Roles)
            ? obj.Roles.map(r => r.ID) : [];
          return obj;
        });
        this.items = list;
        this.pager.size = response.data.size;
        this.pager.page = response.data.page;
        this.pager.total = response.data.total;
        if (this.pager.page > response.data.last_page) {
          this.querier.page = response.data.last_page;
          this.getItemList();
        }
        this.loading = false;
      }, ({ response }) => {
        this.$sys.alarmResponse(response);
        this.loading = false;
      });
    },
    getEmptyItem() {
      return {
        Name: '', // 用户名
        Username: '', // 登录名
        Password: '',
        Phone: '',
        RoleIDs: [],
        DepartmentIDs: [],
      };
    },
    onSubmitQuery() {
      this.querier = {
        ...this.pager,
        where: {
          Name: `like:${this.former.name}`,
        },
      };
      if (this.pager.page !== 1) {
        // changePage会监测页码的变化，自动调用getStaffList
        this.pager.page = 1;
      }
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.querier.page = page;
      this.getItemList();
    },
    addItem() {
      this.item = this.getEmptyItem();
      this.editing = true;
    },
    editItem(row) {
      this.item = row;
      this.editing = true;
    },
    delItem(row) {
      this.$confirm('确定要删除这个用户吗？').then(
        () => this.$axios.delete(`user/${row.ID}`)
      ).then(() => {
        this.$message.success('成功删除用户');
        this.getItemList();
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
      this.getItemList();
    },
  },
};
</script>

<style lang="scss">
.user-box {
  .el-input__inner {
    height: 31px !important;
    line-height: 31px;
  }
  .el-input__icon {
    height: 31px !important;
    line-height: 31px;
  }
}
</style>
